import {
  DownloadIcon,
  PDFIcon,
  PresentationIcon,
  SheetIcon,
  WordDocumentIcon,
} from "@/assets/icons";
import { ILessonMedia } from "@/types/lesson.types";
import { Link } from "react-router-dom";

type Props = {
  attachment: ILessonMedia | string;
};

function getFileExtension(filename) {
  var ext = /^.+\.([^.]+)$/.exec(filename);
  return ext == null ? "" : ext[1];
}

const isAttachmentString = (attachment: ILessonMedia | string): attachment is string => typeof attachment === "string"

const returnAttachmentIcon = (url) => {
  const fileType = getFileExtension(url);
  if (fileType === "pdf") return <PDFIcon />;
  else if (fileType === "doc" || fileType === "docx" || fileType === "txt")
    return <WordDocumentIcon />;
  else if (fileType === "xlsx" || fileType === "xlsm") return <SheetIcon />;
  else if (fileType === "ppt" || fileType === "pptx")
    return <PresentationIcon />;
};

const Attachment = ({ attachment }: Props) => {

  if (isAttachmentString(attachment)) return (
    <Link
      to={`${process.env.REACT_APP_BUCKET_BASEURL}${attachment}`}
      download={true}
      target="_blank"
      className="flex items-center gap-2 rounded-lg border border-[#E5E9F2] px-2 py-2"
    >
      {returnAttachmentIcon(attachment)}
      <p className="max-w-[350px] truncate font-sans text-sm font-semibold text-[#3A4250]">
        Attachment
      </p>
      <DownloadIcon />
    </Link>
  )

  return (
    <Link
      to={`${process.env.REACT_APP_BUCKET_BASEURL}${attachment?.url}`}
      download={true}
      target="_blank"
      className="flex items-center gap-2 rounded-lg border border-[#E5E9F2] px-2 py-2"
    >
      {returnAttachmentIcon(attachment?.url)}
      <p className="max-w-[350px] truncate font-sans text-sm font-semibold text-[#3A4250]">
        {attachment?.name}
      </p>
      <DownloadIcon />
    </Link>
  );
};

export default Attachment;
